// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Monad from "../Control.Monad/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
var monadEffect = {
    Applicative0: function () {
        return applicativeEffect;
    },
    Bind1: function () {
        return bindEffect;
    }
};
var bindEffect = {
    bind: $foreign.bindE,
    Apply0: function () {
        return applyEffect;
    }
};
var applyEffect = {
    apply: Control_Monad.ap(monadEffect),
    Functor0: function () {
        return functorEffect;
    }
};
var applicativeEffect = {
    pure: $foreign.pureE,
    Apply0: function () {
        return applyEffect;
    }
};
var functorEffect = {
    map: Control_Applicative.liftA1(applicativeEffect)
};
var semigroupEffect = function (dictSemigroup) {
    return {
        append: Control_Apply.lift2(applyEffect)(Data_Semigroup.append(dictSemigroup))
    };
};
var monoidEffect = function (dictMonoid) {
    return {
        mempty: $foreign.pureE(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupEffect(dictMonoid.Semigroup0());
        }
    };
};
export {
    untilE,
    whileE,
    forE,
    foreachE
} from "./foreign.js";
export {
    functorEffect,
    applyEffect,
    applicativeEffect,
    bindEffect,
    monadEffect,
    semigroupEffect,
    monoidEffect
};
//# sourceMappingURL=index.js.map
